<template>
	<div class="case-card d-flex flex-column flex-sm-row">
		<div class="img d-none d-sm-block">
			<img :src="data.img.url" alt="">
		</div>
		<div class="content d-flex flex-column justify-content-between align-items-start">
			<div class="ttl">
				<p>{{data.city.title}}</p>
				<p>{{data.title}}</p>
			</div>
			<div class="img d-block d-sm-none">
				<img :src="data.img.url" alt="">
			</div>
			<div class="custom-br"></div>
			<div class="count">
				<p class="subttl">Количество домов</p>
				<div class="d-flex justify-content-start align-items-center">
					<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
						<path
							d="M59.5742 27.8392C59.5703 27.7801 59.5675 27.7201 59.5561 27.663C59.5484 27.6211 59.5342 27.583 59.5218 27.542C59.5075 27.4935 59.497 27.444 59.477 27.3973C59.4599 27.3563 59.437 27.3182 59.417 27.2792C59.3961 27.2373 59.3751 27.1935 59.3494 27.1544C59.3265 27.1182 59.297 27.0868 59.2713 27.0535C59.2408 27.0144 59.2113 26.9744 59.177 26.9392C59.1484 26.9097 59.1161 26.8859 59.0846 26.8592C59.0456 26.8259 59.0094 26.7906 58.9665 26.7611C58.9304 26.7363 58.8904 26.7173 58.8513 26.6954C58.8094 26.6716 58.7694 26.6459 58.7246 26.6268C58.6751 26.6059 58.6227 26.5916 58.5704 26.5754C58.5351 26.5649 58.5027 26.5497 58.4665 26.5411L31.4294 20.5268V2.24205C31.4294 1.45252 30.7894 0.813477 30.0008 0.813477H1.84654C1.05702 0.813477 0.417969 1.45252 0.417969 2.24205V57.7582C0.417969 58.5468 1.05702 59.1868 1.84654 59.1868H30.0008H58.1561C58.9446 59.1868 59.5846 58.5468 59.5846 57.7582V27.9363C59.5846 27.903 59.577 27.8725 59.5742 27.8392ZM3.27511 3.67062H28.5723V21.6487C28.5723 21.6497 28.5723 21.6506 28.5723 21.6516V21.6725V56.3297H22.9694V43.2182C22.9694 42.4297 22.3304 41.7897 21.5408 41.7897H10.3056C9.51606 41.7897 8.87702 42.4297 8.87702 43.2182V56.3306H3.27511V3.67062ZM20.1123 56.3297H11.7342V44.6468H20.1123V56.3297ZM49.4342 56.3297H45.5065V44.6468H49.4342V56.3297ZM42.6494 56.3297H38.7218V44.6468H42.6494V56.3297ZM52.2913 56.3297V43.2182C52.2913 42.4297 51.6513 41.7897 50.8627 41.7897H37.2932C36.5046 41.7897 35.8646 42.4297 35.8646 43.2182V56.3306H31.4294V23.4544L56.7275 29.083V56.3306H52.2913V56.3297Z"
							fill="#D14647"/>
						<path
							d="M6.40513 15.435H13.147C13.9366 15.435 14.5756 14.7959 14.5756 14.0064V7.26451C14.5756 6.47499 13.9366 5.83594 13.147 5.83594H6.40513C5.61561 5.83594 4.97656 6.47499 4.97656 7.26451V14.0064C4.97656 14.795 5.61561 15.435 6.40513 15.435ZM7.83371 8.69308H11.7185V12.5778H7.83371V8.69308Z"
							fill="#D14647"/>
						<path
							d="M18.6981 15.435H25.44C26.2295 15.435 26.8686 14.7959 26.8686 14.0064V7.26451C26.8686 6.47499 26.2295 5.83594 25.44 5.83594H18.6981C17.9086 5.83594 17.2695 6.47499 17.2695 7.26451V14.0064C17.2695 14.795 17.9095 15.435 18.6981 15.435ZM20.1267 8.69308H24.0114V12.5778H20.1267V8.69308Z"
							fill="#D14647"/>
						<path
							d="M13.1461 39.4924C13.9356 39.4924 14.5747 38.8524 14.5747 38.0638V31.3229C14.5747 30.5343 13.9356 29.8943 13.1461 29.8943H6.40513C5.61561 29.8943 4.97656 30.5343 4.97656 31.3229V38.0638C4.97656 38.8524 5.61561 39.4924 6.40513 39.4924H13.1461ZM7.83371 32.7514H11.7185V36.6352H7.83371V32.7514Z"
							fill="#D14647"/>
						<path
							d="M18.6981 39.4924H25.44C26.2295 39.4924 26.8686 38.8524 26.8686 38.0638V31.3229C26.8686 30.5343 26.2295 29.8943 25.44 29.8943H18.6981C17.9086 29.8943 17.2695 30.5343 17.2695 31.3229V38.0638C17.2695 38.8524 17.9095 39.4924 18.6981 39.4924ZM20.1267 32.7514H24.0114V36.6352H20.1267V32.7514Z"
							fill="#D14647"/>
						<path
							d="M6.40513 27.4631H13.147C13.9366 27.4631 14.5756 26.824 14.5756 26.0345V19.2926C14.5756 18.5031 13.9366 17.864 13.147 17.864H6.40513C5.61561 17.864 4.97656 18.5031 4.97656 19.2926V26.0345C4.97656 26.824 5.61561 27.4631 6.40513 27.4631ZM7.83371 20.7221H11.7185V24.6069H7.83371V20.7221Z"
							fill="#D14647"/>
						<path
							d="M18.6981 27.4631H25.44C26.2295 27.4631 26.8686 26.824 26.8686 26.0345V19.2926C26.8686 18.5031 26.2295 17.864 25.44 17.864H18.6981C17.9086 17.864 17.2695 18.5031 17.2695 19.2926V26.0345C17.2695 26.824 17.9095 27.4631 18.6981 27.4631ZM20.1267 20.7221H24.0114V24.6069H20.1267V20.7221Z"
							fill="#D14647"/>
						<path
							d="M41.3004 30.1057H34.5594C33.7709 30.1057 33.1309 30.7457 33.1309 31.5343V38.2752C33.1309 39.0638 33.7709 39.7038 34.5594 39.7038H41.3004C42.089 39.7038 42.729 39.0638 42.729 38.2752V31.5343C42.729 30.7457 42.089 30.1057 41.3004 30.1057ZM39.8718 36.8467H35.988V32.9629H39.8718V36.8467Z"
							fill="#D14647"/>
						<path
							d="M53.5934 30.1057H46.8524C46.0638 30.1057 45.4238 30.7457 45.4238 31.5343V38.2752C45.4238 39.0638 46.0638 39.7038 46.8524 39.7038H53.5934C54.3819 39.7038 55.0219 39.0638 55.0219 38.2752V31.5343C55.0219 30.7457 54.3829 30.1057 53.5934 30.1057ZM52.1648 36.8467H48.281V32.9629H52.1648V36.8467Z"
							fill="#D14647"/>
					</svg>
					<p class="num">{{data.text}}</p>
				</div>
			</div>
			<div class="custom-br"></div>
			<div class="date">
				<p class="subttl">срок реализации проекта</p>
				<div class="d-flex justify-content-start align-items-center">
					<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
						<path
							d="M14.9993 0C6.7284 0 0 6.72906 0 14.9993C0 23.2709 6.72906 30 15 30C23.2703 30 29.9993 23.2709 29.9993 15C29.9993 6.72906 23.2703 0 14.9993 0ZM15 26.7124C8.54184 26.7124 3.2876 21.4575 3.2876 14.9993C3.2876 8.54118 8.54184 3.2876 15 3.2876C21.4575 3.2876 26.7117 8.54184 26.7117 14.9993C26.7117 21.4575 21.4575 26.7124 15 26.7124Z"
							fill="#191919"/>
						<path
							d="M19.8772 13.3561H16.6323V6.78223C16.6323 5.87419 15.8966 5.13843 14.9885 5.13843C14.0805 5.13843 13.3447 5.87419 13.3447 6.78223V14.9999C13.3447 15.9079 14.0805 16.6437 14.9885 16.6437C14.9912 16.6437 14.9931 16.6431 14.9958 16.6431C14.9977 16.6431 15.0004 16.6437 15.0023 16.6437H19.8772C20.7852 16.6437 21.521 15.9079 21.521 14.9999C21.521 14.0919 20.7852 13.3561 19.8772 13.3561Z"
							fill="#191919"/>
					</svg>
					<p class="period">{{data.text2}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	//const axios = require('axios');
	export default {
		props: {
			data: Object,
		},
		data() {
			return {}
		}
	}
</script>

<style lang="scss" scoped>
	
	.case-card {
		position: relative;
		width: 100%;
		min-height: 387px;
		@media only screen and (max-width: $md), only screen and (max-device-width: $md) {
			margin-bottom: 20px;
			min-height: auto;
		}
		.img {
			width: 150px;
			@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
				width: 100%;
				height: 111px;
				margin-bottom: 20px;
			}
			img {
				height: 100%;
				width: 100%;
			object-fit: cover;
			object-position: center;
				@media only screen and (max-width: $sm), only screen and (max-device-width: $sm){
					width: calc(100% + 30px);
					margin-left: -15px;
					margin-bottom: 20px;
				}
			}
			
		}
		
		.content {
			width: 100%;
			padding: 28px 10px 30px 25px;
			background: #FFFFFF;
			filter: drop-shadow(0px 0px 24px rgba(0, 0, 0, 0.06));
			/*box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.06);*/
			position: relative;
			/*z-index: 5;*/
			@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
				padding: 30px 15px;
				border-radius: 10px;
				&::before {
					content: '';
					position: absolute;
					width: 20px;
					height: 20px;
					left: 50%;
					transform: translateX(-50%);
					bottom: -20px;
					border: 10px solid transparent;
					border-top: 10px solid #FFFFFF;
				}
			}
			&::after {
				content: '';
				width: 20px;
				height: 20px;
				filter: drop-shadow(3px 0px 2px rgba(0, 0, 0, 0.1));
				position: absolute;
				right: -20px;
				top: 50%;
				border: 10px solid transparent;
				border-left: 10px solid #FFFFFF;
				@media only screen and (max-width: $md), only screen and (max-device-width:$md){
					display: none;
				}
			}
			.ttl {
				font-weight: 500;
				font-size: 22px;
				line-height: 120%;
				color: $mainFontColor;
				@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
					margin-bottom: 20px;
				}
			}
			
			.count {
				.subttl {
					font-weight: 500;
					font-size: 16px;
					line-height: 100%;
					text-transform: uppercase;
					color: $secondFontColor;
					margin-bottom: 10px;
					@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
						margin-bottom: 10px;
					}
				}
				
				.num {
					font-size: 72px;
					line-height: 100%;
					color: $activeColor;
					margin-left: 15px;
					@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
						font-size: 50px;
						margin-bottom: 15px;
					}
				}
				svg {
					@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
						width: 45px;
						height: 45px;
						margin-bottom: 15px;
					}
				}
			}
			
			.date {
				.subttl {
					font-weight: 500;
					font-size: 16px;
					line-height: 100%;
					text-transform: uppercase;
					color: $secondFontColor;
					margin-bottom: 10px;
					@media only screen and (max-width: $sm), only screen and (max-device-width: $sm){
						margin-bottom: 10px;
					}
				}
				
				.period {
					font-weight: 700;
					font-size: 22px;
					line-height: 100%;
					color: $mainFontColor;
					margin-left: 15px;
				}
			}
		}
		.custom-br {
			width: calc(100% + 35px);
			transform: translateX(-25px);
			height: 1px;
			background-color: #EFEFEF;
			@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
				margin-bottom: 15px;
			}
		}
		
	}

</style>